import { PublicLayout } from "../../components/PublicLayout";
import { StatusTag } from "../../components/StatusTag";

export function LimitedChallengePage() {
  return (
    <PublicLayout title="月初爆分挑戰" subtitle="即將開放">
      <section className="limited-event-panel locked">
        <StatusTag label="即將開放" tone="soon" />
        <h2>活動尚未啟用</h2>
        <p>活動內容仍在準備中，正式開放後會在大廳公告。</p>
      </section>
    </PublicLayout>
  );
}
